import { useCreatePublicTokenMutation } from '../queries/useCreatePublicTokenMutation'
import { useDeletePublicTokenMutation } from '../queries/useDeletePublicTokenMutation'
import { usePublicTokenQuery } from '../queries/usePublicTokenQuery'

export const useHeadless = () => {
  const { publicTokenQuery, invalidatePublicTokenQuery } = usePublicTokenQuery()
  const { createPublicTokenMutation } = useCreatePublicTokenMutation()
  const { deletePublicTokenMutation } = useDeletePublicTokenMutation()

  const handlePublicTokenCreate = () => {
    createPublicTokenMutation.mutate([], {
      onSuccess: () => {
        invalidatePublicTokenQuery()
      },
    })
  }

  const handlePublicTokenDelete = (token: string) => {
    deletePublicTokenMutation.mutate([token], {
      onSuccess: () => {
        invalidatePublicTokenQuery()
      },
    })
  }

  const loading =
    publicTokenQuery.isLoading ||
    createPublicTokenMutation.isLoading ||
    deletePublicTokenMutation.isLoading

  const publicTokens = publicTokenQuery.data?.results || []

  return {
    handlePublicTokenCreate,
    handlePublicTokenDelete,
    loading,
    publicTokens,
  }
}
